import log from 'loglevel';
import { Instance, onSnapshot } from 'mobx-state-tree';

import { isInDebugMode } from '../../util';
import { ROOT_STATE_STORAGE_KEY } from '../../util/constants';
import { Environment } from '../environment';
import { createEmptyState, RootStore, RootStoreModel } from './RootStore';

/**
 * Setup the root state.
 */
export async function setupRootStore(env: Environment) {
  let rootStore: RootStore;
  let data: Instance<typeof RootStoreModel>;

  await env.setup();

  try {
    // load data from storage
    data = await env.localStorage.get(ROOT_STATE_STORAGE_KEY);
    rootStore = createEmptyState(env, data);
  } catch (e: unknown) {
    // if there's any problems loading, then let's at least fallback to an empty state
    // instead of crashing.

    rootStore = createEmptyState(env);

    // but please inform us  what happened
    if (isInDebugMode()) {
      log.error((e as Error).message, null);
    }
  }

  // track changes & save to storage
  onSnapshot(rootStore, (snapshot) => {
    env.localStorage.set(ROOT_STATE_STORAGE_KEY, snapshot);
  });

  return rootStore;
}
